import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';

export interface ModelCardData {
  id: string;
  title: string;
  shortDescription?: string;
  organization: string;
  industry?: string;
  tags: string[];
  modelType?: string;
  language?: string;
  date?: string;
  badge?: string;
  badgeColor?: 'public' | 'restricted' | 'private';
  isNew?: boolean;
  link?: string;
  metrics?: {
    likes?: number;
    views?: number;
    downloads?: number;
    files?: number;
  };
}

@Component({
  selector: 'app-model-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './model-card.html',
  styleUrl: './model-card.scss',
})
export class ModelCard {
  private router = inject(Router);
  private googleAnalytics = inject(GoogleAnalyticsService);

  @Input({ required: true }) card!: ModelCardData;

  formatMetric(n: number | undefined): string {
    const v = n ?? 0;
    if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}M`;
    if (v >= 1_000) return `${(v / 1_000).toFixed(1)}k`;
    return String(v);
  }

  getBadgeModifierClass(): string {
    const c = this.card.badgeColor ?? 'public';
    if (c === 'restricted') {
      return 'model-card__badge--public';
    }
    return `model-card__badge--${c}`;
  }

  onCardClick(): void {
    if (this.card?.id) {
      this.googleAnalytics.trackModelClick(this.card.title ?? '', this.card.id);
      void this.router.navigate(['/model', this.card.id]);
    } else if (this.card?.link) {
      void this.router.navigateByUrl(this.card.link);
    }
  }

  onArrowClick(event: Event): void {
    event.stopPropagation();
    this.onCardClick();
  }
}
